import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Thinking({ label = "Assistant is responding", className, ...rest }) {
    return (_jsxs("div", { className: cn("fwfa-thinking", className), role: "status", "aria-live": "polite", ...rest, children: [_jsxs("span", { className: "fwfa-thinking-dots", "aria-hidden": "true", children: [_jsx("span", {}), _jsx("span", {}), _jsx("span", {})] }), _jsx("span", { className: "fwfa-sr-only", children: label })] }));
}
//# sourceMappingURL=Thinking.js.map